// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3wP5z","disabled":"FileBtn_disabled__38VKP","warn":"FileBtn_warn__2PiZK","fade":"FileBtn_fade__1dhcl"};